export default {
    debug: false,
    state: {
        defaultLanguage: '',
        languages: [],
        isPreview: false,
        currentLanguge: '',
        settings: [],
        blocks: [],
        pages: [],
        post_pagination: true,
        page: 1,
        total_pages: 1,
        vm: null
    },
    init(type, data) {
        this.state[type] = data;
    },
    compare(a, b) {
        const votesA = a.counts.scount;
        const votesB = b.counts.scount;

        let comparison = 0;
        if (votesA > votesB) {
            comparison = -1;
        } else if (votesA < votesB) {
            comparison = 1;
        }

        return comparison;
    },
    updateBlocks(index, block) {
        const tmp = JSON.parse(JSON.stringify(this.state.blocks));
        tmp[index] = block;
        this.state.blocks = tmp;
    },
};
